module.exports = __webpack_public_path__ + "static/media/Real-Estate-Law.d1b9290d.jpg";